export default {
    "TTK": {
        "Text": "Triathlon Total Knee",
        "Parameters": [
            {
                "TTK.FemoralComponent": {
                    "Text": "Femoral Component",
                    "Items": {
                        "TTK.FemoralComponent.CR": {
                            "Text": "CR"
                        },
                        "TTK.FemoralComponent.PS": {
                            "Text": "PS (PS Saw)"
                        },
                        "TTK.FemoralComponent.PSReam": {
                            "Text": "PS Ream"
                        }
                    }
                }
            },
            {
                "TTK.InsertType": {
                    "Text": "Insert Type",
                    "Items": {
                        "TTK.InsertType.CR": {
                            "Text": "CR"
                        },
                        "TTK.InsertType.CSPCLProtect": {
                            "Text": "CS (PCL Protect)"
                        },
                        "TTK.InsertType.CSPCLResect": {
                            "Text": "CS (PCL Resect)"
                        },
                        "TTK.InsertType.PS": {
                            "Text": "PS"
                        },
                        "TTK.InsertType.TS": {
                            "Text": "TS"
                        }
                    }
                }
            },
            {
                "TTK.Baseplate": {
                    "Text": "Baseplate",
                    "Items": {
                        "TTK.Baseplate.Cruciform": {
                            "Text": "Cruciform (Primary)"
                        },
                        "TTK.Baseplate.Universal": {
                            "Text": "Universal"
                        },
                        "TTK.Baseplate.Tritanium": {
                            "Text": "Tritanium"
                        },
                        "TTK.Baseplate.AllPoly": {
                            "Text": "All-Poly"
                        }
                    }
                }
            }
        ],
        "ImplantData": {
            "TTK.FemoralImplantSize": {
                "Text": "Femoral Implant Size"
            },
            "TTK.TibialImplantSize": {
                "Text": "Tibial Implant Size"
            }
        },
        "ValidCombinations": [
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CR", "TTK.Baseplate.Cruciform" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CR", "TTK.Baseplate.Universal" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CR", "TTK.Baseplate.Tritanium" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CSPCLProtect", "TTK.Baseplate.Cruciform" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CSPCLProtect", "TTK.Baseplate.Universal" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CSPCLProtect", "TTK.Baseplate.Tritanium" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CSPCLProtect", "TTK.Baseplate.AllPoly" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.Cruciform" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.Universal" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.Tritanium" ],
            [ "TTK.FemoralComponent.CR", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.AllPoly" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.Cruciform" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.Universal" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.Tritanium" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.AllPoly" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.PS", "TTK.Baseplate.Cruciform" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.PS", "TTK.Baseplate.Universal" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.PS", "TTK.Baseplate.Tritanium" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.PS", "TTK.Baseplate.AllPoly" ],
            [ "TTK.FemoralComponent.PS", "TTK.InsertType.TS", "TTK.Baseplate.Universal" ],
            [ "TTK.FemoralComponent.PSReam", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.Cruciform" ],
            [ "TTK.FemoralComponent.PSReam", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.Universal" ],
            [ "TTK.FemoralComponent.PSReam", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.Tritanium" ],
            [ "TTK.FemoralComponent.PSReam", "TTK.InsertType.CSPCLResect", "TTK.Baseplate.AllPoly" ],
            [ "TTK.FemoralComponent.PSReam", "TTK.InsertType.PS", "TTK.Baseplate.Cruciform" ],
            [ "TTK.FemoralComponent.PSReam", "TTK.InsertType.PS", "TTK.Baseplate.Universal" ],
            [ "TTK.FemoralComponent.PSReam", "TTK.InsertType.PS", "TTK.Baseplate.Tritanium" ],
            [ "TTK.FemoralComponent.PSReam", "TTK.InsertType.PS", "TTK.Baseplate.AllPoly" ],
            [ "TTK.FemoralComponent.PSReam", "TTK.InsertType.TS", "TTK.Baseplate.Universal" ]
        ]
    }
}